<template>
  <div class="container-fluid new_Header" v-if="!isLoading">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('previewdetails.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3">
              <router-link to="/previewlist">
                {{$t('previewdetails.breadcrumb_2')}}
              </router-link>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">
              {{$t('previewdetails.breadcrumb_3')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <mainloader v-if="isLoading" />
    <div v-else class="row pt-3">
      <div class="col">
        <div class="row retrieve">
          <div class="col-auto button-center">
            <img src="/assets/images/icons/gray-clock.png" alt="">
          </div>
          <div class="col">
            <div class="fonttext-14 almarai-regular">{{ dateInspection }}</div>
            <div class="fonttext-14 almarai-regular">{{ row.row.time }}</div>
          </div>
          
          <div class="col-auto button-center" v-if="reservationStatus != 'canceled_client' && reservationStatus != 'canceled' && reservationStatus != 'done'">
            <button :disabled="isPreviewExpired" @click.prevent="cancelPreview" class="btn-close"></button>
          </div>
        </div>

        <div class="row" v-if="billUrl">
          <div class="col-8 col-md-2 btn-bill my-2">
            <a :href="BASE_URL+billUrl" target="_blank" type="application/pdf">
              <div>
                <img src="/assets/images/icons/receipt-text.png" class="max-22" alt="">
                <span class="mx-2">{{$t('invoiceDetails')}}</span>
              </div>
            </a>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col">
            <div class="almarai-bold">{{$t('previewdetails.title_1')}}</div>
          </div>
        </div>

        <div v-if="row.row.Property" class="row pt-3">
          <div class="col-12 col-md-3 mb-3">
            <div class="card card-border m-auto">
              <div class="card-body padding-8">
                <div class="row statusBar pt-2 position-R">
                  <div class="col-auto tag-style">
                    <span>{{ row.row.Property.PropertyType.name}}</span>
                  </div>
                  <div class="col-auto tag-style">
                    <span>{{row.statusChoices[row.row.Property.status]}}</span>
                  </div>
                  <div class="col-auto tag-style">
                    <span class="">{{(row.purpose == 'for_rent') ? $t('rent') : (row.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                  </div>
                </div>
                <swiper v-if="row.row.Property.mediaFiles.length" class="text-center" :modules="[Pagination, Navigation]" :pagination="{ clickable: true }" :navigation="false">
                  <swiper-slide v-for="(val, index) in row.row.Property.mediaFiles" :key="index">
                    <img :src="MEDIA_URL+val.thumbnail" alt="Slide Image" class="img-fluid br-radius" />
                  </swiper-slide>
                </swiper>
                <div v-else>
                  <placeHolder />
                </div>
                <div class="almarai-regular">{{ row.row.Property.title }}</div>
                <div class="pt-2">
                  <i class="fa-solid fa-location-dot gray-color"></i>
                  <span class=" mx-2 gray-color fonttext-14">{{row.row.Property.Neighborhood.name}}</span>
                  <span class="gray-color fonttext-14">{{row.row.Property.City.name}}</span>
                </div>
                <hr class="border-color-w">
                <div class="row end-card space">
                  <div class="col">
                    <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                    <span class="green-color-F almarai-bold">{{ row.row.Property.price }}</span>
                    <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                  </div>
                  <div v-if="row.row.Property.roomsCount" class="col-auto content-center">
                    <span><img :src="MEDIA_URL+row.countedIcons.roomsCount.path" class="max-width-28" alt=""></span>
                    <span class="numbers">{{ row.row.Property.roomsCount }}</span>
                  </div>
                  <div v-if="row.row.Property.bathrooms" class="col-auto border_Icons">
                    <span><img :src="MEDIA_URL+row.countedIcons.bathrooms.path" class="max-width-28" alt=""></span>
                    <span class="numbers">{{ row.row.Property.bathrooms }}</span>
                  </div>
                  <div v-if="!row.row.Property.bathrooms && !row.row.Property.roomsCount && row.row.Property.area" class="col-auto border_Icons">
                    <span><img :src="MEDIA_URL+row.countedIcons.area.path" class="max-width-28" alt=""></span>
                    <span class="numbers">{{ row.row.Property.area }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col">
            <!-- begin:agentData -->
            <div class="row" v-if="Agent">
              <div class="col-auto">
                <div class="row">
                  <div class="almarai-bold py-2">{{$t('previewdetails.title_2')}}</div>
                  <div class="col-auto button-center" >
                    <div class="agent-logo">
                      <img :src="MEDIA_URL+row.row.Property.Agent.avatar" class="w-100" alt="">
                    </div>
                  </div>
                  <div class="col-auto content-center p-0">
                    <div class="almarai-regular">
                      <span v-if="row.row.Property.Agent" >{{row.row.Property.Agent.name}}</span>
                      <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                    </div>
                    <span class="almarai-regular agent-color">{{$t('previewdetails.title_3')}}</span>
                  </div>
                </div>
              </div>

              <div class="col content-center">
                <div class="row justify-content-end preview-socialMedia">
                  <div class="col-auto text-center text-md-end" v-if="row.row.status == 'waiting_payment'">
                    <!-- <div class="text-center"  v-if="loading"><loader/></div> -->
                    <button class="btn btn-gold" @click.prevent="methodPayment">{{$t('previewdetails.title_4')}}</button>
                  </div>
                  <div class="col-auto">
                    <span v-if="row.row.Property.Agent">
                      <a :href="'https://wa.me/'+row.row.Property.Agent.mobile" target="_blank">
                        <!-- <img src="/assets/images/Frame-whatsapp.png" class="img-fluid" alt=""> -->
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                  <div class="col-auto">
                    <span class="mx-2" v-if="row.row.Property.Agent">
                      <a :href="'tel:'+row.row.Property.Agent.mobile" target="_blank">
                        <!-- <img src="/assets/images/Frame-call.png" class="img-fluid" alt=""> -->
                        <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- begin:owner_Data -->
            <!-- <div class="row">
              <div class="almarai-bold py-2">{{$t('previewdetails.ownerName')}}</div>
              <div class="col-auto">
                <div class="row">
                  <div class="col-auto content-center">
                    <div class="agent-logo">
                      <img :src="MEDIA_URL+adCreator.avatar" class="w-100" alt="">
                    </div>
                  </div>
                  <div class="col-auto content-center p-0">
                    <div class="almarai-regular">
                      <span >{{adCreator.name}}</span>
                      <img src="/assets/images/verify-1.png" class="w-24 mx-2" alt="">
                    </div>
                    <span class="almarai-regular agent-color">{{$t('previewdetails.ownerName')}}</span>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row justify-content-end preview-socialMedia">
                  <div class="col-auto">
                    <div class="col-auto text-center text-md-end" v-if="row.row.status == 'waiting_payment'">
                      <button class="btn btn-gold" @click.prevent="methodPayment">{{$t('previewdetails.title_4')}}</button>
                    </div>
                  </div>
                  <div class="col-auto">
                    <span>
                      <a :href="'https://wa.me/'+adCreator.mobile" target="_blank">
                        <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                  <div class="col-auto">
                    <span class="mx-2">
                      <a :href="'tel:'+adCreator.mobile" target="_blank">
                        <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
            <!--end:owner_Data -->
          </div>
        </div>

        <!--begin:location-->
        <div class="row pt-3" v-if="!isLoading && row.row.Property.latitude && parseFloat(row.row.Property.latitude) != 0 && row.row.Property.longitude && parseFloat(row.row.Property.longitude) != 0">
          <div class="col">
            <div class="almarai-bold py-2">{{$t('previewdetails.title_5')}}</div>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
          </div>
        </div>
      </div>
      <!--end:location-->

      
    </div>
    <!--begin:modal Preview-->
    <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="modalPreview">
      <div class="modal-dialog max-W550">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row pt-3">
              <div class="col text-center">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('previewdetails.title_6')}}</div>
                <div class="fonttext-14 gray-color almarai-regular">{{$t('previewdetails.title_7')}}</div>
                <div class="fonttext-14 gray-color almarai-regular">{{$t('previewdetails.title_8')}}</div>
              </div>
            </div>
            <div class="row pt-4 justify-content-center">
              <div @click="modalHidden" class="col-12 col-md-8 mouse-hand">
                <div class="back almarai-bold text-center">{{$t('previewdetails.title_9')}}</div>
              </div>
            </div>
            <div class="row py-3 justify-content-center">
              <div class="col-12 col-md-8 mouse-hand" @click="deleteReservation">
                <div class="cancel-btn almarai-bold text-center">{{$t('previewdetails.title_10')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Preview--->

    <!--begin:modal reservationCancel-->
    <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="reservationDelete">
      <div class="modal-dialog max-W550">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/tick-circle.png" alt="">
              </div>
            </div>
            <div class="row pt-3">
              <div class="col text-center">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('previewdetails.title_11')}}</div>
                <div class="gray-color almarai-regular"></div>
                <div class="text-center gray-color almarai-regular">{{$t('previewdetails.title_12')}}</div>
              </div>
            </div>
            <div class="row py-3 justify-content-center">
              <div class="col-11 col-md-6 mouse-hand text-center">
                <router-link to="/">
                  <div class="back almarai-bold text-center">{{$t('previewdetails.btn_backHome')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal reservationCancel--->

    <!-- begin:modal-payment -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 pb-1">
            <h1 class="modal-title fs-5 pt-2" id="paymentModalLabel">{{$t('wallet.title_12')}}</h1>
            <button type="button" id="closeModal" class="btn-close p-3 m-0" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <errorAlert v-if="payError" :alertMessage="message" :errorNumber="errorNumber" />
          <div class="modal-body">
            <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/Frame_41.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_14')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-11 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div class="input-style">
                    <input class="form-check-input radio-left" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/img-3.png" class="width-icon" alt="">
                    <span class="mx-2">{{$t('wallet.title_16')}}</span>
                  </div>
                </label>
              </div>
            </div>
            <div class="row pt-5">
              <div v-if="loading" class="text-center"> 
                <loader /> 
              </div>
              <div v-else class="col mouse-hand" @click.prevent="payReservation">
                <div class="btn-gold">{{$t('wallet.title_15')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:modal-payment -->

    <!--begin:modal reservationConfirm-->
    <div class="modal hidden-Fileds bg-color-B" tabindex="-1" id="reservationConfirm">
      <div class="modal-dialog max-W550">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row justify-content-center pt-3">
              <div class="col-12 text-center">
                <img src="/assets/images/tick-circle.png" alt="">
              </div>
            </div>
            <div class="row pt-3">
              <div class="col text-center">
                <div class="font-24 almarai-bold text-center mb-1">{{$t('previewdetails.confirmMsg')}}</div>
              </div>
            </div>
            <div class="row py-3 justify-content-center">
              <div class="col-11 col-md-6 mouse-hand">
                <router-link to="/">
                  <div class="back almarai-bold text-center">{{$t('previewdetails.btn_backHome')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal reservationConfirm --->
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { mapGetters } from "vuex";
export default {
  name: "previewdetails",
  data(){
    return {
      retrieveId: this.$route.params.id,
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: true,
      row: {},
      loading: false,
      payError: false,
      reservationStatus: '',
      Agent: {},
      adCreator: {},
      paymentGate: "",
      userLang: 'ar',
      billUrl: null,
      isPreviewExpired: false,
      dateInspection: "",
      toDay: new Date(),
    }
  },
  setup() {
    return {
      Pagination,
      Navigation,
    };
  },
  components: { Swiper, SwiperSlide },
  computed:{
    ...mapGetters(['MEDIA_URL', 'BASE_URL'])
  },
  methods: {
    getDataRetrieve(){
      this.hasError = false;
      this.$http.get('/api/reservation/get/'+this.retrieveId).then(res => {
        // console.log(res);
        // this.Agent = res.data.row.Property.Agent ?? {};
        this.row = res.data;
        this.dateInspection = res.data.row.date;
        this.reservationStatus = res.data.row.status;
        this.Agent = res.data.row.Property.Agent;
        this.adCreator = res.data.row.Property.adCreator.User;
        this.initialGoogleMap();
        this.getBill();
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    payReservation(){
      this.payError = false;
      this.loading = true;
      this.$http.post("/api/reservation/pay",{
        reservationId: parseInt(this.retrieveId),
        paymentGate: this.paymentGate,
      }).then(res => {
        if(this.paymentGate == 'online' && res.data.paymentUrl ){
          window.location.href= res.data.paymentUrl;
        }else{
          if(this.paymentGate == 'wallet'){
            document.getElementById('closeModal').click();
          }
          documnet.getElementById('reservationConfirm').style.display = 'block';
        }
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.payError = true;
        window.scroll(0,0);
      });
    },

    cancelPreview(){
      if (this.dateInspection < this.toDay) {
        this.isPreviewExpired = true;
        alert('لا يمكن إلغاء المعاينة بعد موعدها');
        this.message = " ldjffl;asjf;lsadjfl;kjadsl;flkadsflasdfl;dsjf";
        this.hasError = true;
        return false;
      }
      console.log(this.toDay);
      
      document.getElementById('modalPreview').style.display = 'block';
    },

    modalHidden(){
      document.getElementById('modalPreview').style.display = 'none';
    },

    deleteReservation(){
      this.$http.get('/api/reservation/cancel/'+this.retrieveId).then(res => {
        // console.log(res);
        this.modalHidden();
        document.getElementById('reservationDelete').style.display = "block";
      })
    },

    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.row.row.Property.latitude) ? parseFloat(this.row.row.Property.latitude) : 24.7136, 
          lng: (this.row.row.Property.longitude) ? parseFloat(this.row.row.Property.longitude) : 46.6753 
        },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.row.row.Property.latitude) ? parseFloat(this.row.row.Property.latitude) : 24.7136, 
          lng: (this.row.row.Property.longitude) ? parseFloat(this.row.row.Property.longitude) : 46.6753 
        },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },

    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    methodPayment(){
      document.getElementById('selectPayment').click();
    },

    getBill(){
      this.$http.get('/api/bills/Reservations/'+this.retrieveId).then(res => {
        if(res.data.url)
          this.billUrl = res.data.url
      }).catch(() => {});
    },
  },
  created(){
    this.getDataRetrieve();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>